import type { QueryClient } from '@tanstack/react-query';
import { invalidateScopeSize } from '@/features/insights/queries/useScopeSize';
import { invalidateHealthSummary } from '@/features/insights-dashboard/queries/useHealthSummary';
import { invalidateInsightsItemsDataSet } from '@/features/insights-dashboard/queries/useInsightsDataSetQuery';
import { invalidateTrendsProgress } from '@/features/insights-dashboard/queries/useTrendsProgress';
import { invalidateVarianceBreakdown } from '@/features/insights-dashboard/queries/useVarianceBreakdown';
import { invalidateObjectiveHealth } from '@/features/objectives/queries/useObjectiveHealthQuery';

export const invalidateInsightsData = (queryClient: QueryClient) => {
  invalidateInsightsItemsDataSet(queryClient);
  invalidateHealthSummary(queryClient);
  invalidateTrendsProgress(queryClient);
  invalidateVarianceBreakdown(queryClient);
  invalidateScopeSize(queryClient);
  invalidateObjectiveHealth(queryClient);
};
